module.exports = __webpack_public_path__ + "assets-cabinet/img/back.44e95610.svg";